<template>
<div>
    <!-- <el-button type="success" icon="el-icon-plus" size="small" class="add-case-btn" v-if="jurisdiction.user.add" @click="add">新增用户</el-button> -->
    <el-button type="success" icon="el-icon-plus" size="small" class="add-case-btn" @click="add">新增用户</el-button>
    <SearchForm @submit="searchFormSubmit"/>
    <CustomTable
      :data="newTableData"
      :header="tableHeader"
      @pageSizeChange="handleSizeChange"
      @currentPageChange="handleCurrentChange"
      :settings="{
        isLoading: loading,
        currentPage: pageNum,
        pageSize: pageSize,
        total: total
      }"
      >
        <template slot="headerImage" slot-scope="data">
          <el-image
            style="width: 50px; height: 50px"
            :src="data.scope.row.headImg"
            fit="cover" @click="show(data.scope.index)"></el-image>
        </template>
        <template slot="video" slot-scope="data">
          <el-button v-if="data.scope.row.url" size="small" @click="player(data.scope.row.url)">查看视频</el-button>
          <span v-else>暂无</span>
        </template>
        <template slot="action" slot-scope="data">
          <el-button size="small" v-if="jurisdiction.user.info" @click="onDetalis('see', data.scope.row.userId)">查看详情</el-button>
          <el-button size="small" type="primary" v-if="jurisdiction.user.info" @click="onDetalis('edit', data.scope.row.userId)">修改</el-button>
          <el-button size="small" type="primary" v-if="jurisdiction.user.info" @click="onSetSign(data.scope.row.name, data.scope.row.userId, data.scope.row.notaryId, data.scope.row.videoId, data.scope.row.disabledBtn)">个性化设置</el-button>
        </template>
      </CustomTable>

    <!-- 查看图片 -->
    <viewer :images="headImg" class="viewer" ref="viewer" @inited="inited">
      <img v-for="(item, index) in headImg" :src="item.src" :key="item.key+index" class="image">
    </viewer>
    <!-- 弹窗表单 -->
    <!-- <DialogForm ref="dialogForm" @saveSuccess="getList"/> -->
    <!-- 详细信息表单 -->
    <NotaryDetails ref="notaryDetails" :currUserId="currUserId" @updateList="getList"/>
    <DialogSelectSign ref="dialogSelectSign"
    :name="propsName"
    :userId="propsUserId"
    :disabledBtn="disabledBtn"
    :notaryId="notaryId"
    :videoId="videoId"
    @success="getList"/>
    <VideoPlayer ref="videoPlayer"/>
</div>
</template>

<script>
import NotaryDetails from './notary-details';
import DialogSelectSign from './dialog-selectSign';
import {mapGetters} from 'vuex';
import SearchForm from './search-form';
import VideoPlayer from "@/components/videoPlayer.vue";
import CustomTable from '@/components/custom-table.vue';
export default {
  components: {
    NotaryDetails,
    SearchForm,
    DialogSelectSign,
    VideoPlayer,
    CustomTable
  },
  data() {
    return {
      loading: false,
      tableData: [],
      total: 1,
      pageSize: 10,
      pageNum: 1,
      headImg: [],
      childShow: false,
      currUserId: 0,
      propsName: '',
      propsUserId: '',
      disabledBtn: false,
      notaryId: null,
      videoId: null,
      tableHeader: [
        {
          prop: 'name',
          label: '姓名',
        },
        {
          prop: 'username',
          label: '账号',
        },
        {
          prop: 'custNo',
          label: '签名编码',
        },
        {
          label: '头像',
          slotName: 'headerImage'
        },
        {
          prop: 'roleName',
          label: '角色',
        },
        {
          label: '公证视频',
          slotName: 'video'
        },
        {
          label: '操作',
          width: 300,
          slotName: 'action'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      depts: 'enum/depts',
      jurisdiction: 'login/jurisdiction'
    }),
    newTableData() {
      let tempData = [...this.tableData];
      tempData.map((item, index) => {
        this.headImg.push({
          src: item.headImg,
          key: new Date().getTime()
        });
        this.depts.forEach(k => {
          if (item.deptId == k.value) {
            item.dept_name = k.label;
          }
        })
        item.disabledBtn = item.custNo ? true : false;
      })
      return tempData;
    },
  },
  mounted() {
    // 获取部门列表
    this.$store.dispatch('enum/updateDepts');
    this.getList();
    console.log(this.$route);
  },
  watch: {
    $route: {
      immediate: true,
      handler(newValue) {
        if (newValue.fullPath === '/user/roleForm') {
          this.childShow = true;
        } else {
          this.childShow = false;
        }
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getList();
    },
    // 上方搜索栏的提交方法
    searchFormSubmit(params) {
      console.log(params);
      this.getList(params);
    },
    getList(params) {
      this.loading = true;
      this.$api.userList({
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ...params
      }).then(res => {
        if (res.data.code === '200') {
          this.tableData = res.data.data.records;
          this.total = parseInt(res.data.data.total);
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    inited (viewer) {
      this.$viewer = viewer
    },
    show(index) {
      this.$viewer.view(index);
    },
    add() {
      this.$router.push('/user/addUser')
    },
    //
    distribution() {
      this.$refs.notaryForm.open();
    },
    // 删除
    deleteUser(id) {
      this.$api.deleteUser(id).then(res => {
        if (res.data.code === '200') {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getList();
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          });
        }
      })
    },
    // 查看详情
    onDetalis(openType,id) {
      this.$refs.notaryDetails.open(openType);
      this.currUserId = id;
    },
    // 设置签名
    onSetSign(name, userId, notaryId, videoId, disabledBtn) {
      this.propsName = name;
      this.propsUserId = userId.toString();
      this.notaryId = notaryId;
      this.disabledBtn = disabledBtn;
      this.videoId = videoId;
      this.$refs.dialogSelectSign.open();
      // console.log(this.$refs.dialogSelectSign)
    },
    // 视频播放
    player(url) {
      this.$refs.videoPlayer.open(url)
    }
  }
}
</script>
<style scoped>
.add-case-btn {
  margin-bottom: 20px;
}
.head-img{
  width: 50px;
}
.image{
  display: none;
}
</style>
